import React from "react";
import canUseDom from "../../../utils/can-use-dom";

import { Carousel } from '../basic/carousel.js'
import { wrapCollectionLayout } from "@quintype/components";
import { SectionName } from "../basic/section-name.js";
import {collectionSection} from '../collection-templates/collection-layout-helper';
import './half-screen-slider.module.css';
import {getNumberOfStoriesToShow} from "../../utils";

function HalfImageSliderBase({ collection, stories, associatedMetadata, config}) {
  const  {'show_collection_name': collectionName = true} = associatedMetadata;
  return <div className="wrapper">
    {collectionName ? <SectionName hideLink={true} name={collection.name} type="large" section={collectionSection(config, collection)}/> : null}
    <Carousel
      stories={stories}
      infinite={getNumberOfStoriesToShow(associatedMetadata['number_of_stories_to_show']) > 1}
      config={config}
      collection={collection}
      autoplay={associatedMetadata['scroll_speed_ms'] !== 0}
      autoplaySpeed={associatedMetadata['scroll_speed_ms']}
      rtl={config['theme-attributes']['language_direction'] === 'right'}
      showArrows={associatedMetadata['show_arrows']}
      collectionName={associatedMetadata['show_collection_name']}
      numberOfStoriesToShow={getNumberOfStoriesToShow(associatedMetadata['number_of_stories_to_show']) || undefined}
      dots={associatedMetadata['dots']}
      associatedMetadata={associatedMetadata}
    />
  </div>
}

export const HalfImageSlider = wrapCollectionLayout(HalfImageSliderBase);
